export default __webpack_public_path__ + "static/media/poolpic1.2884770a.jpg";